import {action, makeObservable, observable} from 'mobx';
import Get from 'app/utils/Get';

export class ShopLootboxStore {
    constructor() {
        makeObservable(this);
    }

    @observable lootbox = null;

    @observable animationOpenEnd = false;

    @observable openNowLootbox = false;

    @observable buyAndOpenNowLootbox = false;

    @observable animationLootboxFromOtherPage = false;

    @observable lootboxOpeningInProgress = false;

    @observable returnToCasinoAllGamesOnLootboxBack = false;

    @action
    updateLootbox({lootbox}) {
        this.lootbox = lootbox;
    }

    @action
    updateAnimationStatus(value) {
        this.animationOpenEnd = value;
    }

    @action
    updateOpenNowStatus(value) {
        this.openNowLootbox = value;
    }

    @action
    updateBuyAndOpenNowStatus(value) {
        this.buyAndOpenNowLootbox = value;
    }

    @action
    updateAnimationFromOtherPageStatus(value) {
        this.animationLootboxFromOtherPage = value;
    }

    @action
    updateLootboxOpeningInProgress(value) {
        this.lootboxOpeningInProgress = value;
    }

    @action
    setReturnToCasinoAllGamesOnLootboxBack(value) {
        this.returnToCasinoAllGamesOnLootboxBack = value;
    }

    async updateLootboxBySlug(slug, currency) {
        try {
            const response = await new Get({
                url: `/shop/lootboxes/${slug}.json?currency=${currency || ''}`
            }).execute();

            if (!response.ok) {
                this.updateLootbox({lootbox: null});
                return;
            }

            const lootbox = await response.json();
            this.updateLootbox({lootbox});
        } catch (_error) {
            this.updateLootbox({lootbox: null});
        }
    }
}
